var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_vm._t("default"),(_vm.isLoading)?_c('span',{staticClass:"loader__mask"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }